import { Box, Grid, Typography, useTheme } from "@mui/material";
import { GetCohortQuery } from "generated-graphql/graphql";
import { useMemo } from "react";
import { SummaryMetric } from "../SummaryMetric";

type CohortData = NonNullable<GetCohortQuery["cohort"]>;

interface ColoradoSummaryProps {
  cohort: CohortData;
}

export function ColoradoSummary({ cohort }: ColoradoSummaryProps) {
  const theme = useTheme();

  const summaryData = useMemo(() => {
    return {
      readyCount:
        cohort.coChemicalCounts?.facilitiesWithAtLeastOneRfcOverThreshold ?? 0,
      totalChemicals: cohort.coChemicalCounts?.totalRfcsOverThreshold ?? 0,
    };
  }, [cohort.coChemicalCounts]);

  return (
    <Box
      sx={{
        mt: 3,
        pt: 2,
        borderTop: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 500 }}>
        Colorado Details
      </Typography>

      <Grid container spacing={3}>
        <SummaryMetric
          label="Total number of facilities with at least one chemical above reporting thresholds"
          value={summaryData.readyCount}
        />

        <SummaryMetric
          label="Total number of chemicals above reporting thresholds across all facilities"
          value={summaryData.totalChemicals}
        />
      </Grid>
    </Box>
  );
}
